module.exports = __webpack_public_path__ + "static/use2-029c6d1c0a8974bba72f7e9139c882d2.png";